import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { emitDevOtpFromResponse } from './devOtp';
import { API_BASE_URL } from '../config/env';

const apiUrl = API_BASE_URL;

const apiClient: AxiosInstance = axios.create({
  baseURL: apiUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add authorization token to every request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    emitDevOtpFromResponse(response.data);
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Type definitions for method return values
interface ApiResponse<T = any> {
  data: T;
}

// Typed API methods
const get = <T = any>(url: string, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> => {
  return apiClient.get(url, config);
};

const post = <T = any>(url: string, data: any = {}, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> => {
  return apiClient.post(url, data, config);
};

const put = <T = any>(url: string, data: any = {}, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> => {
  return apiClient.put(url, data, config);
};

const patch = <T = any>(url: string, data: any = {}, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> => {
  return apiClient.patch(url, data, config);
};

const del = <T = any>(url: string, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> => {
  return apiClient.delete(url, config);
};

export default {
  get,
  post,
  put,
  patch,
  delete: del,
};
